import firebase from "firebase";
import "firebase/firestore"
const firebaseConfig = {
    apiKey: "AIzaSyBsrRyYEeYmqeuvgfvIgsue1_l_3k8lHR0",
    authDomain: "fir-81c51.firebaseapp.com",
    projectId: "fir-81c51",
    storageBucket: "fir-81c51.appspot.com",
    messagingSenderId: "43927801125",
    appId: "1:43927801125:web:413437d3bb6f2556a2decc",
    measurementId: "G-XTX6Y5BFFG"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
